/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/get_spam_client_descriptions" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementAppGroupIdGetSpamClientDescriptions } from "./constants";
import type { EngagementGetSpamClientDescriptionsResult } from "./types";

export const getEngagementGetSpamClientDescriptions = reactQueryFetcherAdapter(
  engagementAppGroupIdGetSpamClientDescriptions,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementGetSpamClientDescriptionsResult> => {
    return fetch(`/engagement/${appGroupId}/get_spam_client_descriptions`, "GET", {}, { signal });
  }
);
